import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AddressString } from 'types'
import { AvailableValueToken } from 'types/tokens'

import { CreatePoolStep, FeesLimitsStep, StateCreatePool } from './types'

const initialState: StateCreatePool = {
  availableValueTokens: [AvailableValueToken.usdt, AvailableValueToken.usdc],
  employees: {},
  fees: {
    managementFee: null,
    performanceFee: null,
  },
  image: '',
  isPrivate: false,
  limits: {
    approved: null,
    min: null,
  },
  minClientTier: 0,
  name: '',
  notificationEmail: '',
  notificationSettings: {
    depositReceived: true,
    mddUpdated: true,
  },
  period: null,
  riskFactor: '',
  strategy: {
    en: '',
    es: '',
  },
  targetApy: 0,
  ticker: '',
  title: '',
}

export const sliceCreatePool = createSlice({
  initialState,
  name: 'createPool',
  reducers: {
    removeImage: (state) => {
      state.image = ''
    },
    resetPoolForm: () => initialState,
    setCreatePoolStep: (state, { payload }: PayloadAction<CreatePoolStep>) => {
      const {
        availableValueTokens,
        image,
        isPrivate,
        minClientTier,
        name,
        notificationEmail,
        notificationSettings,
        riskFactor,
        strategy,
        ticker,
        title,
      } = payload

      state.name = name
      state.riskFactor = riskFactor
      state.strategy = strategy
      state.ticker = ticker?.toUpperCase()
      state.title = title
      state.isPrivate = isPrivate
      state.image = image
      state.notificationEmail = notificationEmail
      state.notificationSettings = notificationSettings
      state.minClientTier = minClientTier
      state.availableValueTokens = availableValueTokens
    },
    setEmployeePermission: (state, { payload }: PayloadAction<{ address: AddressString; mask: bigint }>) => {
      if (payload.mask === 0n) {
        delete state.employees[payload.address]
        return
      }

      state.employees[payload.address] = payload.mask
    },
    setFeesLimitsStep: (state, { payload }: PayloadAction<FeesLimitsStep>) => {
      const { fees, limits, period, targetApy } = payload
      state.limits = limits
      state.fees = fees
      state.period = period
      state.targetApy = targetApy
    },
    setImage: (state, { payload }: PayloadAction<string>) => {
      state.image = payload
    },
  },
})
export const { removeImage, resetPoolForm, setCreatePoolStep, setEmployeePermission, setFeesLimitsStep, setImage } =
  sliceCreatePool.actions
